import izenuAPI from '../../services/izenuAPI';

// A panel running locally opens the local web app (next dev on :3000), so the
// session stays on localhost and talks to the same local backend.
const IS_LOCAL = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const WEB_APP_URL = process.env.REACT_APP_WEB_APP_URL
    || (IS_LOCAL ? `${window.location.protocol}//${window.location.hostname}:3000` : 'https://app.izenu.ao');
const WEB_APP_HOST = WEB_APP_URL.replace(/^https?:\/\//, '');

// Fields the web app reads from its session (see izenu-web-app types/index.ts).
// The rest of the row stays out of the URL.
const SESSION_FIELDS = [
    'user_id', 'name', 'first_name', 'last_name', 'real_name', 'artist_name',
    'email', 'phone', 'photo', 'bio', 'acc_type', 'verified', 'is_curator',
];

function toBase64Utf8(text) {
    const bytes = new TextEncoder().encode(text);
    let binary = '';
    bytes.forEach((b) => { binary += String.fromCharCode(b); });
    return btoa(binary);
}

/**
 * Opens the web app (app.izenu.ao, or localhost:3000 from a local panel) in a
 * new tab signed in as the artist, on their Studio.
 *
 * The session travels in the URL fragment (#auth=), which the browser never
 * sends to the server, and the web app removes it from the address bar on
 * arrival. It replaces whatever session that browser had on app.izenu.ao.
 */
export default async function openArtistInApp(artist) {
    const label = artist.artist_name || artist.name;
    if (!window.confirm(
        `Abrir o ${WEB_APP_HOST} com a conta de "${label}"?\n\n` +
        'Tudo o que fizeres lá fica feito em nome do artista. ' +
        `Se tiveres sessão iniciada no ${WEB_APP_HOST} neste browser, será substituída.`
    )) return;

    // Opened before the request so the browser treats it as a direct result of
    // the click and does not block it as a pop-up.
    const tab = window.open('about:blank', '_blank');
    if (tab) tab.opener = null;
    try {
        const { data: res } = await izenuAPI.post('/admin/artist/impersonate.php', { user_id: artist.user_id });
        if (!res.response) {
            tab?.close();
            alert(res.message || 'Erro ao abrir a conta do artista');
            return;
        }
        const user = Object.fromEntries(
            SESSION_FIELDS.filter((k) => res.artist[k] !== undefined).map((k) => [k, res.artist[k]])
        );
        user.user_id = Number(user.user_id);
        const auth = toBase64Utf8(JSON.stringify({ user, token: res.token }));
        const url = `${WEB_APP_URL}/studio#auth=${encodeURIComponent(auth)}`;
        if (tab) tab.location.href = url;
        else window.location.href = url;
    } catch (error) {
        tab?.close();
        console.log(error);
        alert('Erro ao abrir a conta do artista');
    }
}
